import $ from 'jquery';
window.$ = window.jQuery = $;
$(document).ready(function()
{
	$(document).on('click', '.load-more-tags', function(event)
	{
		let next_tag_url = $('param[name="next-page-tag"]').val();
		console.log(next_tag_url);
		if (typeof next_tag_url === typeof undefined || next_tag_url == '') 
		{
			return;
		}
		$('.load-more-tags').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
		$	("#overlay").fadeIn(300);　
		});
		let type = "tag";
		$.ajax
		({
			headers: {
						'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
					},
			url: next_tag_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"type":type},
			success: function (ajaxResponse) {
			if (ajaxResponse.markup) 
			{
				$('.btags').append(ajaxResponse.markup);
				$('param[name="next-page-tag"]').val(ajaxResponse.next_tag_url);
			} 
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next-page-tag"]').val() == '') 
				{
					$('.load-more-tags').css("display", "none");
				}
			}
			})
			.done(function() {
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});


//load more blogs 
$(document).ready(function()
{
	$(document).on('click', '.load-more-home-blogs', function(event)
	{
		let next_vendor_url = $('param[name="next-page-home"]').val();
		console.log(next_vendor_url);
		if (typeof next_vendor_url === typeof undefined || next_vendor_url == '') 
		{
			return;
		}
		$('.load-more-home-blogs').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$("#overlay").fadeIn(300);      
		let type="homeblog";
		$.ajax({
			headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url: next_vendor_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"type":type},
			success: function (ajaxResponse) 
			{
				if (ajaxResponse.markup) 
				{
					$('#post').append(ajaxResponse.markup);
					$('param[name="next-page-home"]').val(ajaxResponse.next_home_url);
				}
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next-page-home"]').val() == '') 
				{
					$('.load-more-home-blogs').css("display", "none");
				}
			}
			})
			.done(function() {
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});

//blog author filter
$(document).ready(function()
{
	$(document).on('change', '.blogcat', function(event)
	{
		let url = window.location.origin + '/author/' + document.getElementById("bloglistoptions").value;
	    window.location.href = url;
	});
});

//blog home page
$(document).ready(function()
{
	$(document).on('click', '.load-more-blogs', function(event)
	{
		let next_vendor_url = $('param[name="next-page-blg"]').val();
		console.log(next_vendor_url);
		if (typeof next_vendor_url === typeof undefined || next_vendor_url == '') 
		{
			return;
		}
		$('.load-more-blogs').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
			url: next_vendor_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val()},
			success: function (ajaxResponse) 
			{
				if (ajaxResponse.markup) 
				{
					$('.blog').append(ajaxResponse.markup);
					$('param[name="next-page-blg"]').val(ajaxResponse.next_page_url);
				}
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next-page-blg"]').val() == '') 
				{
					$('.load-more-blogs').css("display", "none");
				}
			}
		})
		.done(function() 
		{
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});

